export const ROUTE_NAMES = {
  LOGIN: 'Login',
  REGISTER: 'Register',
  PRIVACY: 'Privacy',
  TERMS: 'Terms',
  TABS: 'Tabs',
  EVENTS_LIST: 'EventsList',
  EVENT_DETAIL: 'EventDetail',
  AGENDA: 'Agenda',
  PEOPLE_LIST: 'PeopleList',
  PERSON_DETAIL: 'PersonDetail',
  FAVORITES: 'Favorites',
  NETWORKING: 'Networking',
  NETWORK_SCAN: 'NetworkScan',
  PROFILE: 'Profile',
  PROFILE_EDIT: 'ProfileEdit',
  ADMIN: 'Admin',
  QR_SCAN: 'QrScan',
} as const;

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'auth_access_token',
  REFRESH_TOKEN: 'auth_refresh_token',
  USER: 'auth_user',
  LAST_ACTIVITY: 'auth_last_activity',
} as const;
